import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.66797 17.3332V16.6663C4.66797 14.4572 6.45883 12.6665 8.66797 12.6665H11.3346C13.5438 12.6665 15.3346 14.4572 15.3346 16.6663V17.3332M10.0013 4.6665C8.52854 4.6665 7.33464 5.86041 7.33464 7.33317C7.33464 8.80593 8.52854 9.99984 10.0013 9.99984C11.4741 9.99984 12.668 8.80593 12.668 7.33317C12.668 5.86041 11.4741 4.6665 10.0013 4.6665ZM10.0013 19.3332C4.84664 19.3332 0.667969 15.1545 0.667969 9.99984C0.667969 4.84518 4.84664 0.666504 10.0013 0.666504C15.156 0.666504 19.3346 4.84518 19.3346 9.99984C19.3346 15.1545 15.156 19.3332 10.0013 19.3332Z",
  stroke: "currentColor",
  "stroke-linecap": "square"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'UserIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "user",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})